import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent} from '@angular/material/paginator';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { MiscService } from '../../_service/misc.service';
declare var $: any;
@Component({
  selector: 'app-add-edit-affiliate-user',
  templateUrl: './add-edit-affiliate-user.component.html',
  styleUrls: ['./add-edit-affiliate-user.component.css']
})
export class AddEditAffiliateUserComponent implements OnInit {
  userForm: FormGroup;submitted = false;loading:boolean=false;passwordhide:boolean = true;UserId: any = '';myrole:string;
    
  constructor(public miscapi:MiscService,private userapi:UserService,private router:Router,private sharedapi:SharedService,private formBuilder: FormBuilder,public leadapi:LeadsService,private activatedRoute: ActivatedRoute)
  {   

      let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
      let vaildEmailAddress: any = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@" + "[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
      let passwordPattern = "^[a-zA-Z0-9]{8,}$";

      this.userForm = this.formBuilder.group({ 
          'mobile' : [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
          'email': [null, Validators.compose([Validators.pattern(vaildEmailAddress)])],
          'name' : [null, Validators.required],
          'affiliate_type' : [null],
          'password': [null],
          'status' : [null, Validators.required],
          'margin_percentage' : [null],
          
      });

      this.activatedRoute.params.subscribe(params => {
        if (params['user_id']) {
            this.UserId = params['user_id'];
            this.patchUserData();
            // const userPass = this.userForm.get('password');
            // userPass.clearValidators();
            // userPass.updateValueAndValidity();
        }

    });

      

  }

  get f() { return this.userForm.controls; }

  async patchUserData(){
      let userId = {
          "id": this.UserId, 
      }
      await this.userapi.getAffiliateUserData(userId).subscribe((response:any) => {
         if(response.status){
             this.userForm.patchValue({
                  'mobile':response.data.mobile,  
                  'email':response.data.email,  
                  'name':response.data.name,  
                  'affiliate_type':response.data.affiliate_type,
                  'status': response.data.status,
                  'margin_percentage': response.data.margin_percentage,   
             })
         }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  ngOnInit(): void 
  {    
  }

  showPassword() {
      this.passwordhide = !this.passwordhide;
  }

  async createUser(){
      this.submitted = true;
      this.loading = true;
      if (this.userForm.invalid) {
          this.loading = false;
          return;
      }
       //For Update User//
       if(this.UserId){
            this.userForm.value.id= parseInt(this.UserId); 

            await this.userapi.updateAffiliateUsers(this.userForm.value).subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('User Update Successfully');
                this.router.navigateByUrl('/affiliate-users');
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
            }, error => 
            {
                this.sharedapi.checkError(error);
            });  
      }
      else {
         //For add User//
            await this.userapi.addAffiliateUser(this.userForm.value)
            .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('User Added Successfully');
                this.router.navigateByUrl('/affiliate-users');
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
            }, error => 
            {
                this.sharedapi.checkError(error);
            }); 

      }
     
  }


}